module.exports = __webpack_public_path__ + "media/assets/images/blog/pipeline-assistenza-d353daeef0122aea1914ed187b5fa5f4.jpg";